var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',_vm._g({staticClass:"action-type-badge",attrs:{"icon":_vm.icon}},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.type === 'recurrent' ? _vm.isRecurrent : _vm.isTechnical))])])
}
var staticRenderFns = []

export { render, staticRenderFns }